import { Component, computed, input } from '@angular/core';

let nextId = 0;

@Component({
  selector: 'app-sparkline',
  template: `
    <svg [attr.viewBox]="'0 0 ' + width() + ' ' + height()" class="spark" aria-hidden="true">
      <defs>
        <linearGradient [attr.id]="gradId" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" [attr.stop-color]="stroke()" stop-opacity="0.32" />
          <stop offset="100%" [attr.stop-color]="stroke()" stop-opacity="0" />
        </linearGradient>
      </defs>
      @if (geometry(); as geo) {
        <path [attr.d]="geo.area" [attr.fill]="'url(#' + gradId + ')'" />
        <path
          [attr.d]="geo.line"
          fill="none"
          [attr.stroke]="stroke()"
          stroke-width="1.7"
          stroke-linejoin="round"
          stroke-linecap="round"
        />
      }
    </svg>
  `,
})
export class Sparkline {
  readonly points = input<number[]>([]);
  readonly up = input(true);
  readonly width = input(128);
  readonly height = input(40);
  readonly onDark = input(false);
  protected readonly gradId = `spark-${nextId++}`;

  protected readonly stroke = computed(() => {
    if (this.up()) {
      return this.onDark() ? '#9ddeaf' : '#1c7a4d';
    }
    return this.onDark() ? '#f0b2a4' : '#b42318';
  });

  protected readonly geometry = computed(() => {
    const values = this.points();
    const w = this.width();
    const h = this.height();
    if (values.length < 2) {
      return null;
    }
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = max - min || Math.abs(max) * 0.01 || 1;
    const step = w / (values.length - 1);
    const coords = values.map((value, index) => {
      const x = index * step;
      const y = h - ((value - min) / span) * (h - 6) - 3;
      return [x, y] as const;
    });
    const line = coords
      .map((point, index) => `${index === 0 ? 'M' : 'L'}${point[0].toFixed(2)} ${point[1].toFixed(2)}`)
      .join(' ');
    return { line, area: `${line} L${w.toFixed(2)} ${h} L0 ${h} Z` };
  });
}
